import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "22",
      cy: "22.5",
      r: "22",
      fill: "#F8F8F8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF1418",
      d: "M22.312 24.602 19.24 31.5H17l3.375-7.376c-1.585-.805-2.644-2.264-2.644-4.96-.003-3.776 2.39-5.664 5.235-5.664h2.893v18h-1.937v-6.898h-1.61Zm1.61-9.467H22.89c-1.561 0-3.073 1.033-3.073 4.029 0 2.893 1.385 3.825 3.073 3.825h1.033v-7.854Z"
    }, null, -1)
  ]))]))
}
export default { render: render }